// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateStripeSetting_cancelButton__1nQEr","formItem":"UpdateStripeSetting_formItem__3IZvl","buttonsContainer":"UpdateStripeSetting_buttonsContainer__2kwnb"};